module.exports = __webpack_public_path__ + "img/Frame 6@2x.ea88982d.png";